import { useEffect, useState } from 'react'

// 初期値をクライアントサイドで正しく計算（SSR時はfalse）
const getInitialIsPC = () => {
  if (typeof window === 'undefined') return false
  return window.innerWidth >= 1024
}

export const useWindowSize = () => {
  const [isPC, setIsPC] = useState(getInitialIsPC)

  useEffect(() => {
    const checkScreenWidth = () => {
      setIsPC(window.innerWidth >= 1024)
    }

    window.addEventListener('resize', checkScreenWidth)

    return () => {
      window.removeEventListener('resize', checkScreenWidth)
    }
  }, [])

  return { isPC }
}
